import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion } from 'framer-motion';
const scenarios = [{
  emoji: '🛒',
  text: 'Tu hijo se lanza al piso del supermercado mientras todos miran.'
}, {
  emoji: '🛏️',
  text: 'La hora de dormir se convierte en una batalla que nadie gana.'
}, {
  emoji: '🛑',
  text: 'Un simple "no" dispara 40 minutos de llanto, gritos y tensión.'
}, {
  emoji: '🗣️',
  text: 'Tú subes el tono. Él sube más. Terminas gritando más fuerte que lo que querías.'
}];
export function Identification() {
  return <SectionWrapper className="bg-cream py-20" data-id="element-178">
      <h2 className="font-sans text-3xl md:text-4xl font-bold text-ink mb-12 text-center" data-id="element-179">
        ¿Reconoces alguna de estas escenas?
      </h2>

      <div className="space-y-6 mb-16 max-w-2xl mx-auto" data-id="element-180">
        {scenarios.map((scenario, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1,
        duration: 0.4
      }} className="bg-white p-6 md:p-8 rounded-xl shadow-soft border-l-4 border-l-coral flex items-start gap-6" data-id="element-181">
            <span className="text-4xl leading-none shrink-0" data-id="element-182">
              {scenario.emoji}
            </span>
            <p className="font-sans text-lg text-ink-mid leading-relaxed font-medium" data-id="element-183">
              {scenario.text}
            </p>
          </motion.div>)}
      </div>

      <div className="text-center space-y-6 max-w-2xl mx-auto mb-12" data-id="element-184">
        <p className="font-sans text-lg text-ink-mid" data-id="element-185">
          La noche acaba en culpa, agotamiento y esa pregunta que no quieres
          hacerte:
        </p>
        <p className="font-sans text-2xl md:text-3xl font-bold text-ink" data-id="element-186">
          ¿Por qué no puedo manejar esto mejor?
        </p>
      </div>

      <div className="bg-cream-dark p-8 rounded-xl text-center max-w-3xl mx-auto shadow-sm" data-id="element-187">
        <p className="font-sans text-xl font-bold text-ink" data-id="element-188">
          Si marcaste aunque sea UNO de estos puntos, este protocolo fue escrito
          exactamente para ti.
        </p>
      </div>
    </SectionWrapper>;
}